import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { MapPinXIcon } from 'lucide-react'
import { IdEventV4 } from 'models/event'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const locationSpoofingDefinition: SmartSignalDefinition<{ location_spoofing?: IdEventV4['location_spoofing'] }> =
  {
    key: 'location-spoofing',
    label: 'Location spoofing',
    extract: (e) => ({ location_spoofing: e.location_spoofing }),
    icon(e) {
      const p = this.extract(e)?.location_spoofing
      return (
        <MapPinXIcon
          className={clsx('size-4', {
            'text-red-800': p,
          })}
        />
      )
    },
    details(e) {
      return (
        <CodeViewer
          value={formatJSON(this.extract(e))}
          withSearch={false}
          className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
        />
      )
    },
    isDetected(e) {
      const p = this.extract(e)?.location_spoofing
      return p === true
    },
    isWeb: () => false,
    isMobile: () => true,
    searchFor: '"location_spoofing":',
    documentationHash: '#geolocation-spoofing-detection',
    urlParamKey: IdentificationUrlKeys.LocationSpoofing,
  }
